import { CodePriceRequestType, CodePriceType, CodesPricesRequest, CodeUoM, StageItemDetailStage } from '@jms/model';

// Pricebook requests for a job line. The zeroing predicates that used to live here are shared with
// every embedded-item editor — see `@workbuddy/surfaces/embedded-item` (`embedded.item.rules.ts`).

/**
 * Buy price for a code at a UoM.
 *
 * Prices against the stage technician's pricebook, falling back to standard cost when the stage has no
 * technician — the fallback is the buy half's whole answer, so dropping it silently prices at zero.
 */
export function buildBuyPriceRequest(codeName: string, codeUoM: CodeUoM, stage: StageItemDetailStage): CodesPricesRequest {

  const request = {
    codes: [{ codeName, codeUoM }],
    type: CodePriceRequestType.BuyPrice,
    technicianId: stage?.technicianId,
    workOrderId: stage?._id,
  } as CodesPricesRequest;

  if (!stage?.technicianId) {
    request['buyPriceBookId'] = CodePriceType.STANDARD_COST_PRICEBOOK;
  }

  return request;
}

/** Sell price for a code at a UoM, against the stage's sell pricebook. */
export function buildSellPriceRequest(codeName: string, codeUoM: CodeUoM, stage: StageItemDetailStage): CodesPricesRequest {

  return {
    codes: [{ codeName, codeUoM }],
    type: CodePriceRequestType.SellPrice,
    sellPriceBookId: stage?.sellPriceBook,
    workOrderId: stage?._id,
  } as CodesPricesRequest;
}
